<template>
  <z-dialogo 
    ref="dialogo" 
    titulo="Vendas" 
    :dividers="true" 
    largura="1000px"
    altura="483px"
    scrollable
    no-padding
  >
    <template #texto>

      <v-data-table
        disable-sort
        id="pedidos"
        item-key="id"
        :options.sync="pdvStore.pagination"
        :server-items-length="pdvStore.total_de_registros"
        :footer-props="$globals.FOOTER_PROPS"
        :items="pdvStore.pedidos"
        :headers="headers"
        :loading="false"
        fixed-header
        height="483px"
        hide-default-footer	
      >
        <template v-slot:item="{ item }">
          <tr :class="{ novo: item.novo, 'text-decoration-line-through': item.situacao == 'Cancelado' }">
            <td>{{ item.id }}</td>
            <td>{{ item.data | dataBR }}</td>
            <td>{{ item.forma_pagamento }}</td>
            <td class="text-center">
              <v-chip
                style="font-weight: 400;"
                small
                dark
                :color="corChip(item.situacao).color"
              >{{ item.situacao }}</v-chip>
            </td>
            <td class="text-right">{{ item.valor_liquido | valorBR }}</td>
            <td class="text-center text-no-wrap">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="ma-0"
                    :disabled="item.situacao == 'Cancelado'"
                    @click="imprimir(item)"
                  >
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                </template>
                <span>Imprimir Pedido</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>

    </template>

    <template #actions_left>
      <z-date-navigation
        v-model="data"
        class="ml-5"
        @input="pdvStore.listarVendas"
      ></z-date-navigation>
    </template>
    <template #actions_right>
      <v-btn depressed rounded color="primary" @click="fechar">
        ESC - Fechar
      </v-btn>
    </template>
  </z-dialogo>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance } from 'vue';
import { usePDVStore } from '@/app/store/pinia/pdv';
import { useConfigStore } from '@/app/store/pinia/configuracoes';
import { useListasStore } from '@/app/store/pinia/listas';
import { hoje } from '@/app/helpers/utils';

const { proxy } = getCurrentInstance();

const props = defineProps({
  relatorio: {
    type: String,
    default: '',
  },
});

onMounted(() => {
  // abrir();
  data.value = hoje();
});

const pdvStore = usePDVStore();
const configStore = useConfigStore();
const listasStore = useListasStore();
const dialogo = ref(null);
const data = ref(false);

const headers = ref([
  { text: "Pedido", value: "id", width: "80px" },
  { text: "Data", value: "data", width: "80px" },
  { text: "Forma Pagamento", value: "forma_pagamento", width: "150px" },
  { text: "Situação", value: "situacao", align: "center", width: "10px" },
  { text: "Valor", value: "valor_liquido", align: "right", width: "130px", },
  { text: "Opções", value: "opcoes", width: "100px", align: "center", sortable: false, },
]);


const abrir = async () => {
  dialogo.value.abrir();

  pdvStore.listarVendas(data.value);

};

const fechar = () => {
  dialogo.value.fechar();
};

function corChip(situacao) {
  const chips_config = {
    "Orçamento": { color: "blue", text: "blue--text" },
    "Pedido": { color: "red", text: "red--text" },
    "Cancelado": { color: "red", text: "red--text" },
    "Faturado": { color: "green", text: "green--text" },
    // "pdv:venda": { color: "teal", text: "green--text" },
  };

  let item = chips_config[situacao];

  if (!item) {
    return { color: "grey", text: "grey--text" };
  }

  return chips_config[situacao];

}

function imprimir(pedido) {
  pdvStore.impressaoTermica(pedido.id);
}

defineExpose({
  abrir,
  fechar,
});
</script>

<style scoped></style>
